import { inject } from "@angular/core";
import { Router, CanActivateFn } from "@angular/router";
import { StorageService } from "../helpers/storage.service";

export const checkTokenGuard: CanActivateFn = async (_route, _state) => {
  const storageService = inject(StorageService);
  const router = inject(Router);

  const currentUser = storageService.getCurrentUser();

  if (currentUser?.token) {
    // User is authenticated, redirect to dashboard
    router.navigate(["/user/dashboard"]);
    return false;
  }

  // User is not authenticated, allow access to sign-in
  return true;
};
